import { createIcon } from '@chakra-ui/react';
import { jsx as _jsx } from "react/jsx-runtime";
export var BellIcon = createIcon({
  displayName: 'BellIcon',
  viewBox: '0 0 32 32',
  path: /*#__PURE__*/_jsx("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M24.8667 19.92C24.7467 19.8 24.6707 19.636 24.6667 19.4546V12C24.6667 7.21331 20.7867 3.33331 16 3.33331C11.2133 3.33331 7.33333 7.21331 7.33333 12V19.4533C7.32933 19.636 7.25333 19.8 7.13333 19.92L5.05333 22C4.81466 22.2413 4.66666 22.5733 4.66666 22.9386V26C4.66666 26.736 5.264 27.3333 6 27.3333H14C14 28.4373 14.896 29.3333 16 29.3333C17.104 29.3333 18 28.4373 18 27.3333H26C26.736 27.3333 27.3333 26.736 27.3333 26V22.9466C27.3333 22.572 27.1853 22.24 26.9467 22L24.8667 19.92ZM26 26H6V22.9466L8.08 20.8666C8.44266 20.5066 8.66666 20.008 8.66666 19.4573V12C8.66666 7.94931 11.9493 4.66665 16 4.66665C20.0507 4.66665 23.3333 7.94931 23.3333 12V19.4573C23.3333 20.008 23.5573 20.5066 23.92 20.8666L26 22.9466V26Z",
    fill: "currentColor"
  })
});
//# sourceMappingURL=BellIcon.js.map